import React, { forwardRef } from 'react';
import { usePlatformFunctionality } from './context/PlatformFunctionalityProvider';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ children, href, ...rest }, ref) => {
  const { LinkComponent } = usePlatformFunctionality();

  if (LinkComponent) {
    return (
      <LinkComponent to={href} {...rest} ref={ref}>
        {children}
      </LinkComponent>
    );
  }
  return (
    <a href={href} {...rest} ref={ref}>
      {children}
    </a>
  );
});
Link.displayName = 'Link';
